<template>
  <span>{{ formattedTime }}</span>
</template>

<script>
export default {
  props: {
    second: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      timeLeft: this.second,
      timer: null
    };
  },
  computed: {
    formattedTime() {
      const h = Math.floor(this.timeLeft / 3600);
      const m = Math.floor((this.timeLeft % 3600) / 60);
      const s = this.timeLeft % 60;

      return `${this.pad(h)}:${this.pad(m)}:${this.pad(s)}`;
    }
  },
  watch: {
    second(newVal) {
      this.resetTimer(newVal);
    }
  },
  mounted() {
    this.startTimer();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    pad(n) {
      return n < 10 ? '0' + n : n;
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          this.$emit('done');
          clearInterval(this.timer);
        }
      }, 1000);
    },
    resetTimer(seconds) {
      clearInterval(this.timer);
      this.timeLeft = seconds;
      this.startTimer();
    }
  }
};
</script>